import bundle from "@charter/data/bundle";
import { loadGameData, resolveString } from "@charter/data";

/**
 * The typed data bundle, parsed once at module load. A schema mismatch throws here, at boot,
 * which is the loudest and earliest place to fail.
 */
export const gameData = loadGameData(bundle);

/** @public Localised string resolver. Call sites never read strings.csv rows directly. */
export function t(key: string): string {
  return resolveString(gameData, key);
}
